'use client'
import React, { useState } from 'react'
import { Image, ListGroup } from 'react-bootstrap'
import { MdOutlineClear } from 'react-icons/md'
import { FaSearch } from 'react-icons/fa'
import useEnter from '@/hooks/useEnter'
import styles from './page.module.scss'
import Link from 'next/link'
import { getFileUrl } from '@/utils'
import BlogDefault from '@/assets/footer-mb.png'
import { ReactGAEvent } from '@/components/ReactGAs'
import { useRouter } from 'next/navigation'

const _ferrous = ['ms_tmt_bars', 'ms_sheets_|_plates', 'hr_coils', 'cr_coils', 'mild_steel_scrap']
const _nonFerrous = ['aluminium_t_ingots', 'zinc_ingots', 'copper_rod', 'nickel_cathode', 'copper_cathode']

const SearchForm = ({ serachIcon = true, showSearch, setShowSearch, bannerSearch = false, modalCss = false, categoryData = [] }) => {
	const router = useRouter()
	const [searchTerm, setSearchTerm] = useState('')
	const [searchResults, setSearchResults] = useState(categoryData)
	const [selectedItem, setSelectedItem] = useState(-1)
	const [focused, setFocused] = useState(false)
	const ferrous = categoryData?.filter((item) => _ferrous?.includes(item?.category_id))
	const nonFerrous = categoryData?.filter((item) => _nonFerrous?.includes(item?.category_id))

	const loginHandler = () => {
		const findCategory = categoryData?.find((item) => item?.category_name?.toLowerCase().includes(searchTerm))
		searchTerm !== '' && router.push(`/product-details/${findCategory?.slug}`)
		setShowSearch(!showSearch)
	}

	const clickGAEvent = () => {
		ReactGAEvent({ action: 'Search bar click', event: 'Search_bar', label: '', category: 'Select Product' })
	}

	useEnter(loginHandler)

	const searchHandler = (id) => {
		if (id === null) return

		const slugid = id
		clickGAEvent()
		router.push(`/product-details/${slugid}`)
	}

	const onKeyDownHandler = (e) => {
		if (e.keyCode === 40) {
			setSelectedItem((selectedItem + 1) % searchResults.length)
		} else if (e.keyCode === 38) {
			setSelectedItem(selectedItem === 0 ? selectedItem : (selectedItem - 1) % searchResults.length)
		} else if (e.keyCode === 13) {
			if (selectedItem === -1) return
			searchHandler(searchResults[selectedItem].slug)
		}
	}

	const itemListHandler = (itemList) => {
		return (
			<div className={`${styles.landingSectionData}`}>
				{itemList?.map((item, index) => {
					const _imageUrl = item?.image?.includes('http') ? item?.image : getFileUrl + item?.image
					return (
						<div className={`${styles.landingSectionChips} cursor-pointer`} key={index}>
							<Link href={`/product-details/${item?.slug}`} onClick={(e) => setShowSearch(!showSearch)} className='d-flex gap-2'>
								<span className={styles.chipImage}>
									{item?.image && (
										<Image
											src={_imageUrl}
											width={15}
											height={15}
											alt={item?.category_name}
											onError={(e) => {
												e.target.src = `${BlogDefault.src}`
											}}
										/>
									)}
								</span>
								<span className={styles.chipName}>{item?.category_name}</span>
							</Link>
						</div>
					)
				})}
			</div>
		)
	}

	const handleSearchChange = (e) => {
		setSearchTerm(e.target.value)
		let filteredResults = categoryData.filter((item) => item?.category_name?.toLowerCase().includes(e.target.value.toLowerCase()))
		setSearchResults(filteredResults)
		if (!e.target.value) {
			setSearchResults(categoryData)
		}
	}

	const mostSearchedItem = () => {
		return (
			<ListGroup as='ol' className='list-group-flush'>
				{searchResults?.length ? (
					<>
						{' '}
						{searchResults?.map((item, index) => {
							const _imageUrl = item?.image?.includes('http') ? item?.image : getFileUrl + item?.image
							return (
								<Link href={`/product-details/${item?.slug}`} key={index} onClick={(e) => setShowSearch(!showSearch)}>
									<ListGroup.Item
										as='li'
										action
										variant='light'
										className={`d-flex justify-content-between align-items-end border-0 rounded ${styles.mostSearchItem}`}
									>
										<div className='ms-2 me-auto'>
											<p>
												<Image
													src={_imageUrl}
													width={20}
													height={20}
													alt={item?.category_name}
													onError={(e) => {
														e.target.src = `${BlogDefault.src}`
													}}
													roundedCircle
													className='border'
												/>{' '}
												{item?.category_name}
											</p>
											<span>{item?.commodity_name}</span>
										</div>
									</ListGroup.Item>
								</Link>
							)
						})}{' '}
					</>
				) : (
					<ListGroup.Item
						as='li'
						action
						variant='light'
						className={`d-flex justify-content-between align-items-end border-0 rounded ${styles.mostSearchItem}`}
					>
						<div className='ms-2 me-auto'>
							<p>
								<Image
									src={BlogDefault.src}
									width={20}
									height={20}
									alt={'Item Not Found'}
									onError={(e) => {
										e.target.src = `${BlogDefault.src}`
									}}
									roundedCircle
									className='border'
								/>{' '}
								Item Not Found
							</p>
							<span>{searchTerm}</span>
						</div>
					</ListGroup.Item>
				)}
			</ListGroup>
		)
	}

	return (
		<div className={`${styles.HeaderSearch} ${styles.HeaderSearchActive} ${modalCss && 'rounded-0'}`}>
			<div
				className={`${styles.SearchFieldLanding} ${bannerSearch && styles.inputSearchBackground} rounded-0 ${!modalCss && 'rounded-top-4'} ${
					bannerSearch && styles.SearchFieldLandingActive
				} `}
			>
				<div className={`${styles.searchFieldContent} col-12`}>
					<div className='d-flex align-items-center gap-2 px-2 w-100 justify-content-between'>
						<input
							type='text'
							placeholder='Search for'
							autoFocus={true}
							className={`${styles.inputSearch} ${bannerSearch && styles.inputSearchBackground} ${bannerSearch && 'm-2'}`}
							value={searchTerm}
							onChange={handleSearchChange}
							onKeyDown={onKeyDownHandler}
							onFocus={() => setFocused(true)}
							onBlur={() => {
								ReactGAEvent({ action: 'Search bar click', event: 'Search_bar', label: 'Blank', category: 'select product' })
								setFocused(false)
							}}
						/>
						<div onClick={(e) => setShowSearch(!showSearch)} className={`${styles.clearSearch} cursor-pointer z-3`}>
							<MdOutlineClear size={20} />
						</div>
					</div>
				</div>
				{/* {serachIcon && ( */}
				<div
					className={`align-items-center text-end cursor-pointer z-3 position-absolute ${styles.serachIcon}`}
					onClick={(e) => loginHandler()}
				>
					<FaSearch className={styles.searchButton} size={20} />
				</div>
				{/* )} */}
			</div>
			{showSearch && (
				<div className={styles.landingPage}>
					<div className={`${styles.landingSection} ${searchTerm ? 'm-0 mx-1' : ''} ${searchTerm && styles.landingSectionItem}`}>
						{searchTerm ? (
							<div className='my-2'>{mostSearchedItem()}</div>
						) : (
							<div className={`${styles.categoryContainer} row my-2  `}>
								<div className={`border-end col-md-6 col-sm-12 ${styles.borderEnd}`}>
									<div className={`${styles.mostSearchHeading} d-flex align-items-center justify-content-between`}>
										<div className='d-flex gap-1'>
											<span>FERROUS</span>
										</div>
									</div>
									{itemListHandler(ferrous)}
								</div>
								<div className='col-md-6 col-sm-12'>
									<div className={`${styles.mostSearchHeading} d-flex align-items-center justify-content-between`}>
										<div className='d-flex gap-1'>
											<span>NON-FERROUS</span>
										</div>
									</div>
									{itemListHandler(nonFerrous)}
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}

export default SearchForm
